import React, { useRef } from 'react'
import { IErrorResponse } from '../types/ErrorResponse'
import { TCommunityMemberPagination } from '../types/CommunityMember'
import CommunityIntegrationController from '../controllers/CommunityIntegrationController'

export interface IUseCommunityMembersProp {
  productId: string
  page: number
  rows: number
  name?: string
  hasJoined?: boolean | null
}

const valueDefault: TCommunityMemberPagination = {
  items: [],
  page: 0,
  total: 0,
  rowsPerPage: 0,
  totalPages: 0,
  hasBackPage: false,
  hasNextPage: false,
  isLastPage: false,
}

export const useCommunityMembers = ({
  productId,
  page,
  rows,
  name,
  hasJoined,
}: IUseCommunityMembersProp) => {
  const [loading, setLoading] = React.useState<boolean>(false)
  const [data, setData] = React.useState<TCommunityMemberPagination>(valueDefault)
  const [error, setError] = React.useState<string>('')
  const executing = useRef(false)

  const execute = async () => {
    if (!productId || productId === '') return
    if (!loading && !executing.current) {
      executing.current = true
      try {
        setLoading(true)
        if (error !== '') setError('')
        const response = await CommunityIntegrationController.getMembers({
          productId,
          page,
          rows,
          name,
          hasJoined,
        })
        const responseError = response as IErrorResponse
        const responseData = response as TCommunityMemberPagination
        if (responseError.code) {
          setError(responseError.error)
          setData(valueDefault)
        } else {
          setData(responseData)
        }
      } catch (e) {
        let message = 'Erro não identificado'
        if (typeof e === 'string') message = e.toUpperCase()
        else if (e instanceof Error) message = (e as Error).message
        setError(message)
      } finally {
        setLoading(false)
        executing.current = false
      }
    }
  }

  React.useEffect(() => {
    execute()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, page, rows, name, hasJoined])

  const clear = () => setError('')

  return { loading, data, error, execute, clear }
}
